import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ModalPrivacyPolicy } from 'src/components/Modals';
import { SEO } from 'src/components/SEO';

export const Privacy: React.FC = () => {
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate(-1); // Torna alla pagina precedente
  };

  if (!open) return null;
  return (
    <>
      <SEO
        title="Privacy Policy - Kipify"
        robots="noindex, nofollow"
        canonical="https://app.kipify.io/privacy"
      />
      <ModalPrivacyPolicy open={open} onClose={handleClose} />
    </>
  );
};
